export default __webpack_public_path__ + "static/Wwise-c79e8bc6f14f2c607e82288476de3dc6.mp4";